/**
 * Copies text from the given reference input.
 */
export default function () {
    return {
        showInput: false,
        copy: function () {
            this.showInput = true;

            this.$nextTick(() => {
                this.$refs.input.select();
                this.$refs.input.setSelectionRange(0, 99999);
                document.execCommand('copy');

                this.$nextTick(() => {
                    this.showInput = false;
                });
            });
        },
    };
}
